<template>
  <b-card overlay :img-src="image" img-alt="Card Image" text-variant="white">
    <div class="card-img-overlay text-center pt-5">
      <h1 class="text-white">
        {{ heading }}
      </h1>
      <b-row class="pt-5 justify-content-center">
        <b-col cols="4">
          <base-button
            :text="buttonOneText"
            width="90%"
            height="3.5rem"
            :to="buttonOneLink"
            radius="0.15rem"
          />
        </b-col>
        <b-col cols="4">
          <base-button
            :text="buttonTwoText"
            width="90%"
            height="3.5rem"
            :to="buttonTwoLink"
            radius="0.15rem"
          />
        </b-col>
      </b-row>
    </div>
  </b-card>
</template>

<script>
export default {
  props: {
    heading: {
      type: String,
      required: true,
    },
    image: {
      type: String,
      required: true,
    },
    buttonOneLink: {
      type: String,
      required: true,
    },
    buttonOneText: {
      type: String,
      required: true,
    },
    buttonTwoText: {
      type: String,
      required: true,
    },
    buttonTwoLink: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.card-img-overlay {
  background-color: rgba(#000, 0.5);
}
</style>
